import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { FlowBuilder } from "@/features/catalog/flows/flow-builder";
import { flowDefinitionRouteId } from "@/features/catalog/lib/flow-definition-route";

export const Route = createFileRoute("/catalog/flows/new")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canWrite("PlanDefinition")) {
      throw redirect({ to: "/catalog/questionnaires" });
    }
  },
  component: NewFlowComponent,
});

function NewFlowComponent() {
  const navigate = useNavigate();
  return (
    <div className="flex h-full min-h-0 flex-col">
      <FlowBuilder
        canEdit
        onCreated={(url) =>
          navigate({
            to: "/catalog/flows/$flowId",
            params: { flowId: flowDefinitionRouteId(url) },
          })
        }
      />
    </div>
  );
}
